import { Flex, theme } from 'antd'
import { LogoLink, LogoText } from './styles/LogoStyles'

const { useToken } = theme

export function Logo() {
  const { token } = useToken()

  return (
    <LogoLink to="/">
      <Flex align="center" gap="small">
        <LogoText strong color={token.colorText}>
          Bandos
        </LogoText>
      </Flex>
    </LogoLink>
  )
}
